// src/Components/PaginationControls.jsx
import React from 'react';
import styles from '../Pages/UserManagement.module.css';

const PaginationControls = React.memo(({ page, totalPages, setPage }) => {
  
  const handlePrevious = () => {
    setPage(p => Math.max(p - 1, 1));
  };
  
  const handleNext = () => {
    setPage(p => Math.min(p + 1, totalPages));
  };

  return (
    <div className={styles.paginationWrapper}> {/* 💡 Nueva clase para el div style */}
      <button
        onClick={handlePrevious}
        disabled={page === 1}
        className={styles.button}
      >
        « Anterior
      </button>
      <span className={styles.paginationInfo}>Página {page} de {totalPages}</span>
      <button
        onClick={handleNext}
        disabled={page === totalPages}
        className={styles.button}
      >
        Siguiente »
      </button>
    </div>
  );
});

export default PaginationControls;